import useModalAside from '@use/useModalAside/useModalAside';
import { ref, defineAsyncComponent } from 'vue';
import useLoader from '@use/useLoader/useLoader';
import { useBasketStore } from '@/storePinia/stores/basket';

const loader = useLoader();

interface IBasketModalReturn {
  open: () => void;
  close: () => void;
}

export default function useBasketModal(): IBasketModalReturn {
  const isOpen = ref(false);
  const modalAside = useModalAside();

  const open = async (callBack?: () => unknown) => {
    const basketStore = useBasketStore();

    if (basketStore.count !== basketStore.items.length) {
      await basketStore.getData();
    }

    loader.start();
    const Basket = defineAsyncComponent(() => import('@components/Basket/Basket.vue'));

    // eslint-disable-next-line no-underscore-dangle
    await Basket.__asyncLoader?.();

    loader.stop();

    modalAside.show(
      Basket,
      {},
      {
        afterRemove: () => {
          if (typeof callBack === 'function') {
            callBack();
          }
        },
      }
    );
    isOpen.value = true;
  };
  const close = async () => {
    await modalAside.hide();
    isOpen.value = false;
  };
  return {
    // isOpen,
    open,
    close,
  };
}
